import type { SVGProps } from 'react';

const SvgGoTo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m18.71 10.313-4-4a.996.996 0 1 0-1.41 1.41l2.29 2.29H11c-3.31.01-6 2.7-6 6.01 0 .55.45 1 1 1s1-.45 1-1c0-2.21 1.79-4 4-4h4.59l-2.29 2.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l4-4a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgGoTo;
